module.exports = __webpack_public_path__ + "img/interwhite.3f274abc.svg";